import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "stroke-current",
  "data-slot": "icon",
  viewBox: "0 0 16 16",
  fill: "none",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.25 8L2.75 8M13.25 8L10.75 10.5M13.25 8L10.75 5.5",
    "stroke-width": "{1.5}",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)

import VButton from '@/components/Buttons/VButton.vue'

	import { 
		clsx
	} from 'clsx'

	
	const __default__ = { name: 'VPaginationNext' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		className: {
			type: String,
			default: ''
		},
		children: {
			type: String,
			default: "Next"
		},
		href: {
			type: String,
			default: null
		}
	},
  setup(__props) {

	const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(_unref(clsx)(__props.className, 'flex grow basis-0 justify-end'))
  }, [
    _createVNode(VButton, {
      href: __props.href ? __props.href : undefined,
      disabled: __props.href === null ? true : false,
      plain: "",
      "aria-label": "Next page"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.children) + " ", 1),
        _hoisted_1
      ]),
      _: 1
    }, 8, ["href", "disabled"])
  ], 2))
}
}

})